import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-prod-grp2-menu',
  templateUrl: './prod-grp2-menu.component.html',
  styleUrls: ['./prod-grp2-menu.component.css']
})
export class ProdGrp2MenuComponent implements OnInit {
    prodGrp2Id;

    public menu?: Menu;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodGrp2Id = this.stateService.getStateParams()['prodgrp2_id'];
    }

    private async loadMenu() {
        if (!!this.prodGrp2Id) {
            this.menu = (await this.datatask.Post(3072, { prodgrp2_id: this.prodGrp2Id }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_prodgrp2menu_prodgrp3_grid')
                .setLoadDataFunction({
                    method: 3074,
                    parameters: { prodgrp2_id: this.menu?.prodgrp2_id }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'prodgrp2menu_new',
                    text: 'prodgrp2menu_new',
                    func: () => {
                        this.stateService?.go('prodgrp3', {
                            prodgrp2_id: this.menu?.prodgrp2_id,
                            prodgrp3_id: '+'
                        });
                    },
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    prodgrp_id: number;
    prodgrp_name: string;
    prodgrp2_id: number;
    prodgrp2_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrp2Menu', {
//        templateUrl: 'views/components/views/prodGrp2Menu/prodGrp2Menu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'prodGrp2MenuService', 'ttGridFactory', function ($stateParams, stateService, prodGrp2MenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrp2Id = $stateParams.prodgrp2_id;

//            vm.model = {
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_prodgrp2menu_prodgrp3_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'prodgrp2menu_new',
//                    text: 'prodgrp2menu_new',
//                    func: () => {
//                        stateService.go('prodgrp3', {
//                            prodgrp2_id: vm.model.menu.prodgrp2_id,
//                            prodgrp3_id: '+'
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await prodGrp2MenuService.getMenu({ prodgrp2_id: prodGrp2Id }))[0];

//                loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3074,
//                    parameters: { prodgrp2_id: vm.model.menu.prodgrp2_id }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
